// Exams whose topic papers play in the Pearson player. Any other exam's topic paper
// (TMUA, ESAT, the interview exams) plays in the generic player.
const PEARSON_TOPIC_EXAMS = ['LNAT', 'TARA', 'UCAT'];

export function isTmuaPearsonPlayerSitting(examName, activeQuizSource) {
  const exam = String(examName || '').toLowerCase();
  const type = activeQuizSource?.type;
  if (type === 'parameter') {
    return activeQuizSource?.topicPaper === true
      && PEARSON_TOPIC_EXAMS.includes(String(examName || '').toUpperCase());
  }
  if (type !== 'paper') return false;
  if (exam === 'tmua') return true;
  if (exam === 'lnat' || exam === 'esat' || exam === 'tara' || exam === 'ucat') {
    return activeQuizSource?.pearsonSitting === true;
  }
  return false;
}

export function isTaraBmatPearsonSource(source) {
  return Boolean(source?.pearsonSitting && source?.bmatSitting && !source?.tsaSitting);
}
